var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0301 16.015C32.0301 7.17474 24.8553 0 16.015 0C7.17474 0 0 7.17474 0 16.015C0 23.7663 5.50917 30.2204 12.812 31.7098V20.8195H9.60902V16.015H12.812V12.0113C12.812 8.92038 15.3264 6.40601 18.4173 6.40601H22.4211V11.2105H19.218C18.3372 11.2105 17.6165 11.9312 17.6165 12.812V16.015H22.4211V20.8195H17.6165V31.95C25.7041 31.1492 32.0301 24.3268 32.0301 16.015Z",
    fill: "#01126E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.198267d9a466e1dba9246c4b2917776d.svg";
export { ForwardRef as ReactComponent };